import { giphyDarkCharcoal } from '@giphy/colors'
import { useContext, useState } from 'react'
import { IconButton, TextInput } from 'ui'
import { CopilotApiContext } from '../../contexts/api'

type Props = {
    className?: string
}

const CopilotSidebarPresetInput = ({ className }: Props) => {
    const { createNewPreset } = useContext(CopilotApiContext)
    const [value, setValue] = useState<string>('')

    function onInput(value: string) {
        setValue(value.trim())
    }

    function onCreateClick() {
        if (!value) return

        createNewPreset(value)
        setValue('')
    }

    return (
        <TextInput
            autoCorrect
            className={className}
            color={giphyDarkCharcoal}
            placeholder="Create New Preset"
            selectOnFocus
            size="medium"
            spellCheck
            onChange={onInput}
        >
            <IconButton disabled={!value} gradient="indigo-purple" icon="add" size="medium" onClick={onCreateClick} />
        </TextInput>
    )
}

export default CopilotSidebarPresetInput
